import { render } from "./pg_fundingdata.vue?vue&type=template&id=37ea7975&scoped=true"
import script from "./pg_fundingdata.vue?vue&type=script&lang=js"
export * from "./pg_fundingdata.vue?vue&type=script&lang=js"

import "./pg_fundingdata.vue?vue&type=style&index=0&id=37ea7975&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\GCTUSMS\\codev1\\apply_online\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ea7975"]])

export default __exports__